<script lang="ts">
  import {investor, accessLink} from 'Store/InvestorFlowStore';
  import Spinner from 'Components/Common/Spinner.svelte';

  let loading: boolean = true;

  let iframe: HTMLElement;

  const frameLoaded = (): void => {
    loading = false;

    if ($investor && !$investor.access_link) {
      iframe.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  };
</script>

<div class="iframe-container">
  {#if loading}
    <div class="loading" data-testid="iframe-loading">
      <Spinner />
    </div>
  {/if}
  <iframe
    allow="payment"
    bind:this={iframe}
    title="QuestionFlow"
    frameborder="0"
    scrolling="yes"
    src={$accessLink.toString()}
    on:load={frameLoaded}
    data-testid="iframed-question-flow"
  />
</div>

<style>
  .iframe-container {
    height: 100%;
    position: relative;
  }

  iframe {
    height: 100%;
    width: 100%;
    border: none;
  }

  .loading {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    background-color: white;
    opacity: 0.9;
  }
</style>
